import {DataSourceInterface} from './datasource.interface.mjs';
import {BanServicesLib} from '@mecatran/ban-services-lib';


export class BanSearchDataSource extends DataSourceInterface{
    constructor(banSearchConfig){
        super();
        // check type of banSearchConfig 
        var _banLib = new BanServicesLib();
        var _banConfig = _banLib.getConfig();
        _banConfig.setSearchConfig(banSearchConfig);

        Object.defineProperty(this,'lib',{
            get : function(){ return _banLib },
            enumerable : false
        })

        Object.defineProperty(this,'searchConfig',{
            get : function(){  return _banConfig.getSearchConfig() }
        })


    }
    getTypedObject(query){
        console.log('get')
        var banLib = this.lib;
        var searchConfig = this.searchConfig;
        searchConfig.setQuery(query);
        return banLib.search();


    }



}